import api from "../api";

export const tipoinstituicaoService = {
    async loadTypes() {
      return await api.get(`/tipoinstituicao`);
    },
  }